import React, { useEffect, useState } from 'react';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';
import { Text } from '@uhg-abyss/web/ui/Text';
import PropTypes from 'prop-types';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { buildCriterionExpression } from '@coveo/headless';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Box } from '@uhg-abyss/web/ui/Box';
import { event } from '@uhg-abyss/web/tools/event';
import { sortChangeEvent } from '../events';

const Container = styled('div', {
  width: '75%',
  lineHeight: '16px',
});

const FlexStack = styled('div', {
  display: 'flex',
  flexDirection: 'column',
});

export const SortAndFilterSection = ({ controller, criteriaOptions }) => {
  const [sortState, setSortState] = useState(controller.state);

  const getInitialCriteron = () => {
    return criteriaOptions.find(
      ([, criteron]) =>
        sortState.sortCriteria === buildCriterionExpression(criteron)
    );
  };
  const [selected, setSelected] = useState(getInitialCriteron()[0]);

  useEffect(() => {
    controller.subscribe(() => setSortState(controller.state));
  }, [controller]);

  const handleSortSelection = (selection) => {
    const criterionMatch = criteriaOptions.find(([name]) => name === selection);
    event.setData(
      sortChangeEvent({
        searchSort: criterionMatch[0],
        searchEventTrigger: 'resultsSort',
      })
    );
    controller.sortBy(criterionMatch[1]);
  };

  return (
    <Box color="white">
      <Layout.Stack alignItems="left" grow space={15}>
        <Container>
          <FlexStack>
            <Text fontWeight="bold" size={18}>
              Sort
            </Text>
            <Text size="$sm">
              Your results will populate after a selection is made from the
              dropdown below.
            </Text>
          </FlexStack>
        </Container>
        <SelectInput
          enableOutsideScroll
          label="Sort By"
          value={selected}
          onChange={(selection) => {
            setSelected(selection);
            handleSortSelection(selection);
          }}
          options={[
            { value: 'relevancy', label: 'Relevance' },
            { value: 'date descending', label: 'Date (Descending)' },
            { value: 'date ascending', label: 'Date (Ascending)' },
          ]}
        />
        <Container>
          <FlexStack>
            <Text fontWeight="bold" size={18}>
              Filter
            </Text>
            <Text size="$sm">
              Refine your search results by making selections below. New results
              will populate upon selection.
            </Text>
          </FlexStack>
        </Container>
      </Layout.Stack>
    </Box>
  );
};

SortAndFilterSection.propTypes = {
  controller: PropTypes.shape({
    state: PropTypes.shape({
      sortCriteria: PropTypes.string,
    }),
    subscribe: PropTypes.func.isRequired,
    sortBy: PropTypes.func.isRequired,
  }),
  criteriaOptions: PropTypes.arrayOf(PropTypes.array),
};

SortAndFilterSection.defaultProps = {
  controller: {
    state: {
      sortCriteria: '',
    },
  },
  criteriaOptions: [[]],
};
